import { IDmHe } from "../../../model/respone/category/IDmHe";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmHeActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmHe[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IDmHe | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IDmHe,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START : 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};
export const eDmHeActionIds = generateActionTypeIds(
  eDmHeActionsObj,
  "HE"
);
export type IDmHeActionTypes = IGenericActionType<
  typeof eDmHeActionsObj,
  "HE"
>;
